import React from 'react';
import PropTypes from 'prop-types';

const renderIcon = icon => {
  switch (icon) {
    case 'opportunitiesCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
          <path
            d="M7.083 7h15.834C24.067 7 25 7.895 25 9v12c0 1.105-.933 2-2.083 2H7.083C5.933 23 5 22.105 5 21V9c0-1.105.933-2 2.083-2zm1.319 14.723a.849.849 0 0 0 1.106-.391l1.999-4.157 1.655 1.588a.856.856 0 0 0 .736.222.83.83 0 0 0 .61-.452l1.915-3.982 1.662 2.127a.85.85 0 0 0 .8.31.825.825 0 0 0 .658-.537l2.5-7.198a.793.793 0 0 0-.527-1.012c-.437-.14-.909.087-1.054.507l-1.997 5.75-1.546-1.979a.85.85 0 0 0-.755-.315.832.832 0 0 0-.669.46l-2 4.157-1.654-1.588a.856.856 0 0 0-.736-.222.83.83 0 0 0-.61.453l-2.5 5.198a.787.787 0 0 0 .407 1.061z"
            fill="currentColor"
          />
        </g>
      );

    case 'quoteCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
          <path
            d="M19.118 11.154h-.824c-.227 0-.412-.172-.412-.385 0-.212.185-.384.412-.384h.824c.226 0 .411.172.411.384 0 .213-.185.385-.411.385m0 2.308h-.824c-.227 0-.412-.173-.412-.385 0-.212.185-.385.412-.385h.824c.226 0 .411.173.411.385 0 .212-.185.385-.411.385m0 2.307h-.824c-.227 0-.412-.172-.412-.384 0-.213.185-.385.412-.385h.824c.226 0 .411.172.411.385 0 .212-.185.384-.411.384m0 2.308h-.824c-.227 0-.412-.172-.412-.385 0-.212.185-.384.412-.384h.824c.226 0 .411.172.411.384 0 .213-.185.385-.411.385m-3.294-6.923h-4.942c-.227 0-.411-.172-.411-.385 0-.212.184-.384.411-.384h4.942c.226 0 .411.172.411.384 0 .213-.185.385-.411.385m-5.353 1.923c0-.212.184-.385.411-.385h3.294c.227 0 .412.173.412.385 0 .212-.185.385-.412.385h-3.294c-.227 0-.411-.173-.411-.385M15 15.769h-4.118c-.227 0-.411-.172-.411-.384 0-.213.184-.385.411-.385H15c.226 0 .412.172.412.385 0 .212-.186.384-.412.384m-1.647 2.308h-2.47c-.228 0-.412-.172-.412-.385 0-.212.184-.384.411-.384h2.47c.227 0 .413.172.413.384 0 .213-.186.385-.412.385m7.944-12.195L19.94 7.148l-1.355-1.266a.434.434 0 0 0-.583 0l-1.356 1.266-1.355-1.266a.434.434 0 0 0-.584 0l-1.355 1.266-1.356-1.266a.434.434 0 0 0-.583 0L10.06 7.148 8.703 5.882C8.441 5.639 8 5.814 8 6.154v17.692c0 .342.444.514.703.272l1.356-1.266 1.355 1.266c.162.15.422.15.583 0l1.356-1.266 1.355 1.266c.162.15.422.15.584 0l1.355-1.266 1.356 1.266c.161.15.421.15.583 0l1.355-1.266 1.356 1.266c.258.241.703.07.703-.272V6.154c0-.34-.442-.515-.703-.272"
            fill="currentColor"
          />
        </g>
      );

    case 'usersCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
          <path
            d="M20 12c0-1.381-.56-2.631-1.464-3.535A4.985 4.985 0 0 0 15 7c-1.381 0-2.631.56-3.536 1.465A4.984 4.984 0 0 0 10 12c0 1.381.56 2.631 1.464 3.535A4.985 4.985 0 0 0 15 17c1.381 0 2.631-.56 3.536-1.465A4.984 4.984 0 0 0 20 12zM9 22c0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4-3.75 0-6 2-6 4z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      );

    case 'marketCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
          <path
            d="M23 11.136v10.637C23 22.45 22.463 23 21.8 23H8.2c-.663 0-1.2-.55-1.2-1.227V11.136c0-.677.537-1.227 1.2-1.227h13.6c.318 0 .623.13.849.36.225.23.351.542.351.867zm-13.2-4.5c-.22 0-.4-.183-.4-.409C9.4 5.55 9.937 5 10.6 5h8.8c.663 0 1.2.55 1.2 1.227 0 .226-.18.41-.4.41H9.8zm12 2.046c0 .226-.18.409-.4.409H8.6c-.22 0-.4-.183-.4-.41 0-.677.537-1.226 1.2-1.226h11.2c.663 0 1.2.549 1.2 1.227z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      );
    case 'logoutCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
          <path
            d="M21.642 7.51v14.98a.51.51 0 0 1-.51.51H9.512A.511.511 0 0 1 9 22.49v-6.733h5.23l-1.627 2.182a.689.689 0 0 0 .134.958l.006.006a.688.688 0 0 0 .954-.132l2.499-3.348a.681.681 0 0 0 .134-.411v-.024a.681.681 0 0 0-.134-.41l-2.499-3.349a.688.688 0 0 0-.954-.132l-.006.006a.689.689 0 0 0-.134.958l1.628 2.182H9V7.51c0-.282.23-.51.512-.51h11.62a.51.51 0 0 1 .51.51z"
            fill="currentColor"
          />
        </g>
      );

    case 'settingsCircle':
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <path
            d="M25.707 16.391l-1.61.46a.404.404 0 0 0-.284.313 8.368 8.368 0 0 1-.283 1.05.404.404 0 0 0 .089.412l1.166 1.205c.126.13.15.327.06.484l-.503.87a.404.404 0 0 1-.448.19l-1.636-.41a.404.404 0 0 0-.401.129c-.238.27-.493.525-.762.764a.404.404 0 0 0-.128.401l.409 1.634a.404.404 0 0 1-.19.449l-.871.502a.404.404 0 0 1-.483-.06l-1.212-1.17a.404.404 0 0 0-.412-.09 8.39 8.39 0 0 1-1.043.283.405.405 0 0 0-.312.284l-.461 1.616a.404.404 0 0 1-.39.293h-1.005c-.18 0-.339-.12-.389-.293l-.461-1.616a.404.404 0 0 0-.313-.284 8.386 8.386 0 0 1-1.044-.281.404.404 0 0 0-.413.09l-1.208 1.17a.404.404 0 0 1-.484.059l-.87-.503a.404.404 0 0 1-.19-.448l.41-1.637a.404.404 0 0 0-.129-.402 8.538 8.538 0 0 1-.765-.76.404.404 0 0 0-.401-.128l-1.633.408a.404.404 0 0 1-.449-.19l-.503-.87a.404.404 0 0 1 .06-.484l1.168-1.207c.106-.11.14-.27.09-.413a8.39 8.39 0 0 1-.285-1.047.404.404 0 0 0-.284-.312l-1.61-.46a.404.404 0 0 1-.294-.39v-1.005c0-.18.12-.339.293-.389l1.61-.46a.404.404 0 0 0 .284-.312 8.39 8.39 0 0 1 .284-1.05.404.404 0 0 0-.09-.412l-1.166-1.205a.404.404 0 0 1-.06-.484l.503-.87a.404.404 0 0 1 .448-.19l1.636.41a.404.404 0 0 0 .402-.129c.237-.27.492-.525.762-.764a.404.404 0 0 0 .128-.401l-.41-1.634a.404.404 0 0 1 .19-.449l.871-.502a.404.404 0 0 1 .483.06l1.212 1.17c.11.106.27.14.413.09.34-.116.689-.211 1.042-.283a.404.404 0 0 0 .312-.284l.462-1.616A.404.404 0 0 1 14.997 5h1.006c.18 0 .339.12.389.293l.461 1.616a.404.404 0 0 0 .313.284c.354.07.703.165 1.044.281.144.05.303.015.413-.09l1.208-1.169a.404.404 0 0 1 .484-.06l.87.503c.157.09.234.273.19.448l-.41 1.637a.404.404 0 0 0 .13.402c.27.237.525.491.764.76.1.115.254.164.401.128l1.634-.408a.404.404 0 0 1 .448.19l.503.87a.404.404 0 0 1-.06.484l-1.168 1.207a.404.404 0 0 0-.09.413c.118.343.213.692.285 1.047.029.15.138.27.284.312l1.61.46c.174.05.294.209.294.39v1.005c0 .18-.12.339-.293.388zm-14.155-6.29a.195.195 0 0 0-.132-.097.189.189 0 0 0-.158.04C9.831 11.258 9 13.078 9 15c0 1.922.83 3.742 2.262 4.956a.189.189 0 0 0 .158.04.195.195 0 0 0 .132-.098l2.216-3.997c.31-.557.31-1.245 0-1.803l-2.216-3.996zM15.474 9c-.8 0-1.594.15-2.343.443a.212.212 0 0 0-.12.13.223.223 0 0 0 .017.179l2.386 4.284a1.85 1.85 0 0 0 1.612.964h4.765c.06 0 .118-.027.158-.075a.222.222 0 0 0 .049-.174c-.522-3.315-3.284-5.75-6.524-5.751zm6.317 7h-4.765a1.85 1.85 0 0 0-1.612.964l-2.386 4.284a.223.223 0 0 0-.017.18c.02.058.064.106.12.13a6.408 6.408 0 0 0 5.647-.477c1.718-1.029 2.9-2.803 3.22-4.832a.222.222 0 0 0-.049-.174.206.206 0 0 0-.158-.075z"
            fill="currentColor"
            fillRule="nonzero"
          />
          <circle stroke="currentColor" strokeWidth="2" cx="15" cy="15" r="15" />
        </g>
      );

    case 'close':
      return (
        <g stroke="currentColor" strokeWidth="5" fill="none" fillRule="evenodd" strokeLinecap="square">
          <path d="M28 4L4 28M28 28L4 4" />
        </g>
      );

    case 'edit':
      return (
        <path
          d="M.023 31.299l1.469-4.897A5.815 5.815 0 0 1 2.95 23.96L21.617 5.29a.727.727 0 0 1 1.028 0l4.06 4.062a.727.727 0 0 1 0 1.028L8.038 29.049a5.82 5.82 0 0 1-2.443 1.46L.702 31.977a.546.546 0 0 1-.679-.678zM29.365.637l1.999 1.998c.848.849.848 2.224 0 3.073l-2.436 2.435a.724.724 0 0 1-1.025 0l-4.047-4.047a.725.725 0 0 1 0-1.024L26.292.636a2.172 2.172 0 0 1 3.073 0z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'delete':
      return (
        <path
          d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm7 20.2L20.2 23 16 18.8 11.8 23 9 20.2l4.2-4.2L9 11.8 11.8 9l4.2 4.2L20.2 9l2.8 2.8-4.2 4.2 4.2 4.2z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case 'more':
      return (
        <g transform="translate(0 13)" fill="currentColor" fillRule="evenodd">
          <circle cx="3.2" cy="3.2" r="3.2" />
          <circle cx="16" cy="3.2" r="3.2" />
          <circle cx="28.8" cy="3.2" r="3.2" />
        </g>
      );

    case 'arrowDown':
      return (
        <path
          stroke="currentColor"
          strokeWidth="4.655"
          d="M30.364 9.636L15.938 22.364 2.364 9.636"
          fill="none"
          fillRule="evenodd"
        />
      );

    case 'search':
      return (
        <g
          transform="translate(1 1)"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <path d="M29 29l-7.733-7.733" />
          <circle cx="12.429" cy="12.429" r="12.429" />
        </g>
      );

    case 'back':
      return (
        <path
          d="M7.6 14L18.1 3.5a1 1 0 0 0-.007-1.407L16.707.707a1.003 1.003 0 0 0-1.415.001L0 16l15.292 15.292c.391.391 1.03.387 1.415.001l1.386-1.386c.39-.39.384-1.03.006-1.408L7.6 18h23.398A1 1 0 0 0 32 16.99v-1.98c0-.558-.444-1.01-1.002-1.01H7.6z"
          fill="currentColor"
          fillRule="evenodd"
        />
      );

    case 'circle':
      return <circle fill="currentColor" cx="16" cy="16" r="16" fillRule="evenodd" />;

    default:
      return false;
  }
};

const Icon = ({ className, icon }) => (
  <svg viewBox="0 0 32 32" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" className={className}>
    {renderIcon(icon)}
  </svg>
);

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

Icon.defaultProps = {
  className: undefined,
};

export default Icon;
